import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { selectEntitiesByFilters } from "../../../../../shared/store/views/entityView";
import { messagesByStudyGroupsBoardQuery } from "../../../../../shared/utils/entitiesFiltersUtils";
import Widget from "../../../../../shared/components/features/widget/Widget";
import boardType from "../../../../../shared/enums/boardType";
import Message from "../../../../../shared/components/features/message/Message";
import MessagesWidgetEditorFlow from "../../../home/messagesWidget/messagesWidgetEditorFlow/MessagesWidgetEditorFlow";
import Scroll from "../../../../../shared/components/ui/scroll/Scroll";
import actionType from "../../../../../shared/enums/actionType";
import iconsList from "../../../../../shared/components/ui/icons/iconsList";
import noMessagesImg from "../../../../../assests/emptyList/message.png";
import classes from "./MessagesNmmWidget.module.css";

const MessagesNmmWidget = ({ studyGroupIds = [] }) => {

    const listRef = useRef(null);
    const { user, userDetails } = useSelector(state => state.auth);
    const { texts, lang } = useSelector(state => state.translate);
    const messages = useSelector(state => selectEntitiesByFilters(state, messagesByStudyGroupsBoardQuery(lang, studyGroupIds, boardType.messagesByNmm)));
    const [messageDraft, setMessageDraft] = useState({ draft: null, type: "" });

    return (
        <Widget
            color="#BBA9E0"
            title={texts.messagesBoard}
            icon={iconsList.messages}
            className={classes.MessagesWidget}
            contentScrollable={false}
        >
            <div className={classes.MessagesContent}>
                {messages?.length > 0 ? (
                    <Scroll showDots={true} height="100%">
                        <div className={classes.MessagesList} ref={listRef}>
                            {messages.map(message =>
                                <Message
                                    key={message.id}
                                    {...message}
                                    onDelete={message.isOwner ? () => setMessageDraft({ draft: message, type: actionType.delete }) : null}
                                    onEdit={message.isOwner ? () => setMessageDraft({ draft: { ...message, studyGroupId: message.nmmIds?.[0] }, type: actionType.edit }) : null}
                                />

                            )
                            }
                        </div>
                    </Scroll>
                ) : (
                    <div className={classes.NoMessages}>
                        {texts.noMessages}
                        <img src={noMessagesImg} alt={texts.noMessages} className={classes.EmptyImage} />
                    </div>
                )}
                {studyGroupIds.length > 0 && userDetails?.defaultSchool?.toClass > 6 ?
                    window.config.whiteListMessages?.length > 0 ?
                        window.config.whiteListMessages?.includes(user?.exidentifier) && <MessagesWidgetEditorFlow className={classes.MessageInputArea} messageDraft={messageDraft} setMessageDraft={setMessageDraft} studyGroups={studyGroupIds} boardId={boardType.messagesByNmm} />
                        :
                        <MessagesWidgetEditorFlow className={classes.MessageInputArea} messageDraft={messageDraft} setMessageDraft={setMessageDraft} studyGroups={studyGroupIds} boardId={boardType.messagesByNmm} />
                    :
                    null
                }
            </div>
        </Widget >
    );
};
export default MessagesNmmWidget;
